import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import Survey from '../components/survey/Survey'

function SurveyPage (): ReactElement {
  const { surveyId } = useParams()

  if (!surveyId) {
    return <div className='bg-dopage-black min-h-screen' />
  }

  return <Survey surveyId={surveyId} />
}

export default SurveyPage
